/**
 * User type constants and helper functions for the SoulWise marketplace
 */

export const USER_TYPE = {
  practitioner: 'practitioner',
  consumer: 'consumer',
  user: 'user',
};

export const isPractitioner = userType => userType === USER_TYPE.practitioner;
export const isConsumer = userType => userType === USER_TYPE.consumer;
export const isUser = userType => userType === USER_TYPE.user;

export const getUserTypeFromCurrentUser = currentUser =>
  currentUser?.attributes?.profile?.publicData?.userType;

// Minimal helper for inbox tab decision:
// practitioner -> sales, everyone else -> orders
export const defaultInboxTabForUser = currentUser =>
  isPractitioner(getUserTypeFromCurrentUser(currentUser)) ? 'sales' : 'orders';
